jQuery(document).ready(function(){
    jQuery('.wp-block-cover.zoom-on-hover').each(function(){
        let currentCover = jQuery(this);
        currentCover.find('img').wrap(
            jQuery('<div/>').addClass('wp-block-cover-zoom-container')
        )
    })
})